import { types } from 'mobx-state-tree';

import { MoneySourceEnum } from '../definitions/MoneySource';
import OptionalIdentifier from '../types/OptionalIdentifier';


const Asset = types.model('Asset', {
    id: OptionalIdentifier,
    description: types.maybe(types.string),
    amount: types.maybe(types.number),
    moneySource: types.maybe(MoneySourceEnum),
});

export default Asset;
